import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { LAYOUT_CONFIG } from '../../utils/constants';

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const location = useLocation();

    return (
        <div className={`${LAYOUT_CONFIG.container.layout} ${LAYOUT_CONFIG.container.background} ${LAYOUT_CONFIG.container.textColor}`}>
            <Sidebar isOpen={sidebarOpen} />

            <div className={`flex-1 overflow-auto ${LAYOUT_CONFIG.mainContent.transition} ${sidebarOpen ? LAYOUT_CONFIG.mainContent.marginLeft.open : LAYOUT_CONFIG.mainContent.marginLeft.closed
                }`}>
                <TopBar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

                <div className="p-3">
                    <div key={location.pathname} className="animate-fadeIn">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
